/* eslint-disable no-undef */
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { signInRequest } from '~/store/modules/auth/actions';
import { unFormatCpfCnpj } from '~/util/stringutils';

const { REACT_APP_RECAPTCHA_SITE_KEY, REACT_APP_RECAPTCHA_ENABLED } =
  process?.env || {};

export function useReCaptcha() {
  const enabled = String(REACT_APP_RECAPTCHA_ENABLED) === 'true';
  const sitekey = REACT_APP_RECAPTCHA_SITE_KEY || '';

  const dispatch = useDispatch();

  const handleLoginReCaptcha = useCallback(
    async input => {
      if (!enabled) {
        return;
      }

      window.grecaptcha.enterprise.ready(async () => {
        const { login, password } = input;
        const reCaptchaToken = await window.grecaptcha.enterprise.execute(
          sitekey,
          { action: 'login' }
        );

        dispatch(
          signInRequest(unFormatCpfCnpj(login), password, reCaptchaToken)
        );
      });
    },
    [dispatch, enabled, sitekey]
  );

  const handleLoadReCaptcha = useCallback(() => {
    if (!enabled || document.getElementById('recaptcha-script')) {
      return;
    }

    const script = document.createElement('script');

    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${sitekey}`;
    script.id = 'recaptcha-script';
    script.async = true;

    document.head.append(script);
  }, [enabled, sitekey]);

  const handleRemoveReCaptcha = useCallback(() => {
    if (!enabled) {
      return;
    }

    const script = document.getElementById('recaptcha-script');

    if (script) {
      script.remove();
    }

    const recaptchaelems = document.getElementsByClassName('grecaptcha-badge');

    if (recaptchaelems.length) {
      recaptchaelems[0].remove();
    }
  }, [enabled]);

  return {
    enabled,
    handleLoginReCaptcha,
    handleLoadReCaptcha,
    handleRemoveReCaptcha,
  };
}
